const BRIDGE_CALLBACK_NAME = 'bluetoothBridgeFromUniapp'

const NVEASY_BLUETOOTH_STATE = {
  UNBOUND: 'unbound',
  BOUND_CONNECTED: 'boundConnected',
  BOUND_DISCONNECTED: 'boundDisconnected',
  PERMISSION_DISABLED: 'permissionDisabled'
}

const NVEASY_BLUETOOTH_CONFIG = {
  key: '4E9F76411110D3A7',
  manufacturerCode: ''
}

// 播放状态 `status`：0 停止，1 开始，2 暂停，3 继续（暂停/继续需设备支持 `ABILITY_RECORD_PAUSE_RESUME`）
const NVEASY_PLAY_STATE = {
  STOP: 0,
  START: 1,
  PAUSE: 2,
  RESUME: 3
}

const pendingMap = new Map()
let bluetoothEventHandler = null

// 生成单次蓝牙请求 ID，用于匹配 UniApp 异步回调
const createRequestId = () => `${Date.now()}-${Math.random().toString(16).slice(2)}`

// 向 UniApp 宿主发送蓝牙指令，非 UniApp 环境返回失败
const postToNativeHost = (payload) => {
  if (typeof window === 'undefined') return false

  if (window.uni && typeof window.uni.postMessage === 'function') {
    window.uni.postMessage({ data: payload })
    return true
  }

  return false
}

// 兼容宿主回调传入字符串或对象两种数据格式
const parseNativeMessage = (raw) => {
  if (typeof raw !== 'string') return raw

  try {
    return JSON.parse(raw)
  } catch (error) {
    return null
  }
}

// 处理蓝牙指令响应，按 requestId 唤醒对应 Promise
const handleBluetoothCallback = (message) => {
  const pending = pendingMap.get(message.requestId)

  if (!pending) return

  if (message.type === 'bluetooth:error') {
    pendingMap.delete(message.requestId)
    pending.reject(message)
    return
  }

  if (message.phase === 'callback' || message.phase === 'complete' || !message.phase) {
    pendingMap.delete(message.requestId)
  }
  pending.resolve(message)
}

// 统一接收 UniApp 宿主回调，并区分事件通知和指令响应
const handleNativeMessage = (raw) => {
  const message = parseNativeMessage(raw)
  if (!message || typeof message !== 'object') return

  if (message.type === 'bluetooth:event') {
    bluetoothEventHandler && bluetoothEventHandler(message)
    return
  }

  if (message.type === 'bluetooth:callback' || message.type === 'bluetooth:error') {
    handleBluetoothCallback(message)
  }
}

// 调用 UniApp 蓝牙能力，返回与宿主回调绑定的 Promise
const callBluetooth = (action, data = {}) => {
  const requestId = createRequestId()
  const message = {
    type: 'bluetooth',
    action,
    requestId,
    data
  }

  return new Promise((resolve, reject) => {
    pendingMap.set(requestId, { action, resolve, reject })

    const sent = postToNativeHost(message)
    if (!sent) {
      pendingMap.delete(requestId)
      reject(new Error('当前环境不支持蓝牙连接'))
    }
  })
}

// 注册全局蓝牙桥回调，页面关注 bluetooth:event
const registerBluetoothBridge = (eventHandler) => {
  bluetoothEventHandler = eventHandler

  if (typeof window !== 'undefined' && !window[BRIDGE_CALLBACK_NAME]) {
    window[BRIDGE_CALLBACK_NAME] = handleNativeMessage
  }
}

// 清理当前页面注册的桥回调和未完成请求，避免页面卸载后继续响应
const clearBluetoothBridge = (eventHandler) => {
  if (eventHandler && bluetoothEventHandler !== eventHandler) return

  bluetoothEventHandler = null
  pendingMap.clear()

  if (typeof window !== 'undefined' && window[BRIDGE_CALLBACK_NAME] === handleNativeMessage) {
    window[BRIDGE_CALLBACK_NAME] = undefined
  }
}

export {
  NVEASY_BLUETOOTH_STATE,
  NVEASY_BLUETOOTH_CONFIG,
  NVEASY_PLAY_STATE,
  callBluetooth,
  registerBluetoothBridge,
  clearBluetoothBridge
}
